import Vue from "vue";
import {
  Button,
  Form,
  FormModel,
  Input,
  notification,
  Modal,
  message,
  Popconfirm,
  Table,
  Select,
  DatePicker,
  Upload,
  Pagination,
  ConfigProvider,
  Icon,
  Carousel,
  Tooltip,
  Drawer,
  Menu,
  Tag,
  Row,
  Col,
  InputNumber,
  Checkbox,
  Radio,
  Dropdown,
  Tabs,
  Space,
  Divider,
  Progress,
  Tree,
  Empty,
  Transfer,
} from "ant-design-vue";

export default function () {
  [
    Button,
    Form,
    FormModel,
    Input,
    notification,
    Modal,
    message,
    Popconfirm,
    Table,
    Select,
    DatePicker,
    Upload,
    Pagination,
    ConfigProvider,
    Icon,
    Carousel,
    Tooltip,
    Drawer,
    Menu,
    Tag,
    Row,
    Col,
    InputNumber,
    Checkbox,
    Radio,
    Dropdown,
    Tabs,
    Space,
    Divider,
    Progress,
    Tree,
    Empty,
    Transfer,
  ].map((component) => {
    Vue.use(component);
  });
}
